import firebaseContext from '../firebase/firebaseClient';
import * as players from './players';

type SnapshotLike<T> = {
  val(): Record<string, T> | null | undefined;
};

const REACT_APP_CONFIRMATION_EMAIL_REDIRECT = `${window.location.origin.toString()}`;

const auth = () => firebaseContext.auth;
const playerGroupsRef = (uid: string) => firebaseContext.db.ref(`playerGroups/${uid}`);

export const sendEmailVerification = () =>
  auth().currentUser.sendEmailVerification({
    url: REACT_APP_CONFIRMATION_EMAIL_REDIRECT,
  });

export const create = (email: string, password: string, displayName: string) =>
  auth().createUserWithEmailAndPassword(email, password)
    .then(authUser =>
      players
        .set({
          uid: authUser.user.uid,
          image: null,
          displayName,
          email,
        }))
    .then(sendEmailVerification);

export const signIn = (email: string, password: string) =>
  auth().signInWithEmailAndPassword(email, password).then(authUser => {
    players.get(authUser.user.uid).then(e => {
      if (e.val() == null) {
        console.warn('Recreating /player in db');
        players.set({
          uid: authUser.user.uid, email, image: null, displayName: email
        });
      }
    });

    return authUser;
  });

export const signOut = () =>
  auth().signOut();

export const sendPasswordResetEmail = (email: string) =>
  auth().sendPasswordResetEmail(email);

export const updatePassword = (password: string) =>
  auth().currentUser.updatePassword(password);

export const mapUserRoles = (groupsForPlayer: Record<string, Record<string, boolean>>) => {
  const groupRoles = (gr: Record<string, boolean>) => {
    if (typeof gr !== 'object') {
      return ({ admin: false, accountant: false, gameMaster: false });
    }

    return Object.keys(gr || {})
      .map(key => ({
        role: key,
        authorized: gr[key]
      }));
  };

  return Object.keys(groupsForPlayer || {})
    .map(key => ({
      groupId: key,
      roles: groupRoles(groupsForPlayer[key])
    }));
};

const getUserRoles = (userId: string) => {
  const result = playerGroupsRef(userId).once('value')
    .then(snapshot => {
      const groups = snapshot.val() as Record<string, Record<string, boolean>>;
      return mapUserRoles(groups);
    });

  return result;
};

export const onAuthStateChanged = (successCallback: (user: any) => void, failureCallback: () => void) =>
  auth().onAuthStateChanged(authUser => {
    if (authUser) {
      players.get(authUser.uid)
        .then(playersSnap => {
          getUserRoles(authUser.uid)
            .then(roles => {
              const dbPlayer = playersSnap.val();

              // merge auth user and player
              const user = {
                uid: authUser.uid,
                email: authUser.email,
                emailVerified: authUser.emailVerified,
                providerData: authUser.providerData,
                ...dbPlayer,
                roles,
              };

              successCallback(user);
            });
        });
    } else {
      failureCallback();
    }
  });

export const onAuthorizationsChanged = (playerId:string, successCallback: (data: SnapshotLike<any>) => void, failureCallback: () => void) =>
  playerGroupsRef(playerId).on('value', successCallback, failureCallback);
